import React from 'react';
import Icon from '../../../components/AppIcon';

const HowItWorksSection = () => {
  const steps = [
    {
      icon: 'ClipboardList',
      title: 'Personalized Survey',
      description: 'DepthMe learns your goals, patterns, and mindset style.',
      gradient: 'from-purple-500/20 to-blue-500/20'
    },
    {
      icon: 'Compass',
      title: 'Four Daily Guides',
      description: 'Morning, Shadow, Vision, and Night practices keep you grounded.',
      gradient: 'from-blue-500/20 to-cyan-500/20'
    },
    {
      icon: 'Timer',
      title: 'Guided Rituals',
      description: 'Timed rituals make inner work simple, structured, and repeatable.',
      gradient: 'from-cyan-500/20 to-teal-500/20'
    },
    {
      icon: 'RefreshCw',
      title: 'Journal + Regenerate',
      description: 'Reflect on your day and get updated AI guidance over time.',
      gradient: 'from-teal-500/20 to-violet-500/20'
    }
  ];

  return (
    <section className="py-12 px-6 relative">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-8">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground">
            How it works
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {steps?.map((step, index) => (
            <div
              key={step?.title}
              className="group relative glassmorphism p-5 rounded-xl hover-lift transition-all duration-300"
            >
              <div className={`absolute inset-0 bg-gradient-to-br ${step?.gradient} opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-xl`} />
              <div className="relative z-10">
                <div className={`w-10 h-10 rounded-lg bg-gradient-to-br ${step?.gradient} flex items-center justify-center mb-3 group-hover:scale-110 transition-transform duration-300`}>
                  <Icon name={step?.icon} size={20} className="text-foreground" />
                </div>
                <h3 className="text-sm font-bold text-foreground mb-1">{step?.title}</h3>
                <p className="text-xs text-muted-foreground leading-relaxed">{step?.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;
